import { memo, useContext } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';

import { AppState } from 'services/types';
import {
    VirtualizedTableItemValue,
    VirtualizedTableProps
} from 'services/virtualizedTable/types';
import { makeSelectVirtualizedTableItemValue } from 'services/virtualizedTable/selectors';

import VirtualizedTableContext from '../VirtualizedTableContext';
import { VirtualizedTableContextProviderValue } from '../../types';

type OwnProps = VirtualizedTableProps;

export interface ConnectedProps {
    itemValue: ReturnType<
        ReturnType<typeof makeSelectVirtualizedTableItemValue>
    >;
}

export type Props = OwnProps & ConnectedProps;

export const VirtualizedTableItemValueComponent = (
    props: Props
): VirtualizedTableItemValue | null => {
    const { itemValueFormat }: VirtualizedTableContextProviderValue =
        useContext(VirtualizedTableContext);

    const { itemValue, columnKey } = props;

    if (itemValue || itemValue === 0) {
        return itemValueFormat
            ? itemValueFormat(columnKey as string, itemValue)
            : itemValue;
    }

    return null;
};

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    itemValue: makeSelectVirtualizedTableItemValue()
});

export default connect(mapStateToProps)(
    memo(VirtualizedTableItemValueComponent, isEqual)
);
